import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LegacyIcon } from "./legacyIcon.js";
import { FOLDER_TREE_DRAG_APPEND_HELPER_CLASS, FOLDER_TREE_DRAG_MOVE_HELPER_CLASS } from "../../util/folderTreeDrag.js";
function FolderTreeDragHelper({ moveLabel, moveHint, appendLabel, appendHint, moveIcon = "swap", appendIcon = "copy" }) {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: FOLDER_TREE_DRAG_MOVE_HELPER_CLASS,
                children: [
                    /*#__PURE__*/ _jsx(LegacyIcon, {
                        type: moveIcon
                    }),
                    " ",
                    moveLabel,
                    /*#__PURE__*/ _jsx("p", {
                        children: moveHint
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: FOLDER_TREE_DRAG_APPEND_HELPER_CLASS,
                children: [
                    /*#__PURE__*/ _jsx(LegacyIcon, {
                        type: appendIcon
                    }),
                    " ",
                    appendLabel,
                    /*#__PURE__*/ _jsx("p", {
                        children: appendHint
                    })
                ]
            })
        ]
    });
}
export { FolderTreeDragHelper };
